<template>
    <div :class="bgClass" class="rounded-circle stepper-element">
        <div class="d-flex align-items-center justify-content-center h-100">
            <h1 class="text-white mb-0 mt-1">
                {{content}}
            </h1>
        </div>
    </div>
</template>

<script>
export default {
name: "StepperElement",
    props: {
        bgClass: String,
        content: String
    }
}
</script>

<style scoped lang="scss">
    .stepper-element{
        width: 40px;
        height: 40px;
        min-width: 40px;
    }

    @media(min-width: 768px) {
        .stepper-element{
            width: 64px;
            height: 64px;
            min-width: 64px;
        }
    }

    @media(max-width: 767px) {
        .h1{
            font-size: 1.75rem !important;
        }
    }
</style>